import api from './api';

// 登录日志
export interface LoginLog {
  id: string;
  userId: string;
  username: string;
  ip: string;
  location: string;
  browser: string;
  os: string;
  status: number;
  message: string;
  loginTime: string;
}

// 操作日志
export interface OperationLog {
  id: string;
  userId: string;
  username: string;
  module: string;
  action: string;
  method: string;
  url: string;
  ip: string;
  requestParams: string;
  responseData: string;
  status: number;
  errorMsg: string;
  duration: number;
  createdAt: string;
}

// 获取登录日志列表
export const listLoginLogs = (params: {
  page?: number;
  pageSize?: number;
  username?: string;
  ip?: string;
  status?: string;
  startTime?: string;
  endTime?: string;
}) => {
  return api.get<{ list: LoginLog[]; total: number }>('/logs/login', { params });
};

// 删除登录日志
export const deleteLoginLogs = (ids: string[]) => {
  return api.delete('/logs/login', { data: { ids } });
};

// 清空登录日志
export const clearLoginLogs = () => {
  return api.post('/logs/login/clear');
};

// 获取操作日志列表
export const listOperationLogs = (params: {
  page?: number;
  pageSize?: number;
  username?: string;
  module?: string;
  action?: string;
  status?: string;
  startTime?: string;
  endTime?: string;
}) => {
  return api.get<{ list: OperationLog[]; total: number }>('/logs/operation', { params });
};

// 获取操作日志详情
export const getOperationLog = (id: string) => {
  return api.get<OperationLog>(`/logs/operation/${id}`);
};

// 删除操作日志
export const deleteOperationLogs = (ids: string[]) => {
  return api.delete('/logs/operation', { data: { ids } });
};

// 清空操作日志
export const clearOperationLogs = () => {
  return api.post('/logs/operation/clear');
};
